"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.weak-map");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var humanizeReactList = function humanizeReactList(list, options) {
  if (!Array.isArray(list)) {
    throw new TypeError("humanize-react expected an array");
  }

  options = options || {};
  options.conjunction = options.conjunction || "and";
  options.oxfordComma = options.oxfordComma === undefined ? true : options.oxfordComma;
  var listLength = list.length;

  if (listLength === 1) {
    return list[0];
  }

  var humanizedList = [];

  for (var i = 0; i < listLength; i++) {
    if (i === listLength - 1) {
      if (listLength > 2 && options.oxfordComma) {
        humanizedList.push( /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
          key: "".concat(i, "-comma")
        }, ","));
      }

      humanizedList.push( /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: "".concat(i, "-conjunction")
      }, " ", options.conjunction, " "));
    } else if (i !== 0) {
      humanizedList.push( /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: "".concat(i, "-comma")
      }, ", "));
    }

    humanizedList.push( /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
      key: i
    }, list[i]));
  }

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, humanizedList);
};

var _default = humanizeReactList;
exports["default"] = _default;